import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  scrollable?: boolean;
  fullHeight?: boolean;
  actions?: React.ReactNode;
  tooltip?: string;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  children,
  scrollable = false,
  fullHeight = false,
  actions,
  tooltip,
}) => (
  <div
    className={`flex min-h-0 flex-col rounded-2xl border border-gray-100 bg-white p-4 shadow-sm ${
      scrollable ? '' : 'overflow-hidden'
    } ${fullHeight ? 'h-full' : 'h-80'}`}
  >
    <div className="mb-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {tooltip && (
          <Tooltip title={tooltip}>
            <InfoOutlinedIcon fontSize="small" className="text-gray-400 cursor-help" />
          </Tooltip>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
    <div className="flex-1 min-h-0">
      {children}
    </div>
  </div>
);

export default ChartCard;
